/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$(document).on("click",".ColorSwatch",function() {
  var val = $(this).data('tooltip');
  $(".custom_product_image").each(function(){
    $(this).find("[data-slider='" + val + "']").addClass('active_image_variant').siblings().removeClass('active_image_variant');
  });    
});

$(document).ready(function(){
  var currunt_var = $(".ColorSwatchList input.ColorSwatch__Radio:checked").val();
  $(".custom_product_image").each(function(){
    $(this).find("[data-slider='" + currunt_var + "']").addClass('active_image_variant').siblings().removeClass('active_image_variant');
  });

  $(".size_btn").click(function () {
     $('.size-chart-popup').show();
     $('.popup_overlay').addClass('active');
  });
  $(".close_popup_btn").click(function () {
     $('.size-chart-popup').hide();
    $('.popup_overlay').removeClass('active');
  }); 
  
  $(".customize_link").click(function () {
     $('.how-to-customize-popup').show();
     $('.popup_overlays').addClass('active');
  });
  $(".close_popup_btn").click(function () {
     $('.how-to-customize-popup').hide();
    $('.popup_overlays').removeClass('active');
  }); 
  
    $(".ProductListWrapper .ColorSwatch").click(function () {
     var form = $(this).closest('form').addClass('form');
      $(form).find('video').hide();
    }); 

  
  $(".itg_newsletter_btn").click(function (event) {
     event.preventDefault()
    $('.itg_subscribe_popup').show();
    $('.popup_overlay').addClass('active');
  });
  
  $(".close_popup_btn").click(function (event) {
     event.preventDefault()
    $('.itg_subscribe_popup').hide();
    $('.popup_overlay').removeClass('active');
  });
  
  $(".itg_search_btn").click(function (event) {
     event.preventDefault()
    $('.search_box').toggle();
  });
  
  $(".slidebarBtn").click(function(){
      $(".slidebarBtn").toggleClass('toggle');
      $(".filter_sidebar_button").toggleClass('hide_text');
      $(".CollectionInner__Sidebar").toggleClass('active_sidebar');
  });
  
  
  
  //tyler custom code
  //get home video content block and set minimum height to prevent the cutting off of elements  
  $(".owl-height").attr('style','min-height:550px');
  
});



/*
$(document).on("change",".itg_collection_select",function(){
  var value= $(this).val();
  var form = $(this).closest('form').addClass('rohit');
  //alert(value);
  $(form).find('input.itg_collection_input').val(value); 
}); 

$(document).on("click",".ColorSwatch",function(){

  var itgColor = $(this).attr('title'); 
  var itgOption =  $(this).parents('.ProductItem__Info').siblings('.itg_custom_option');
  $(itgOption).find('.itg_Color').val(itgColor).trigger('change');

  var e1 = $(itgOption).find('.sel1 option:selected').val();
  var e2 = $(itgOption).find('.sel2 option:selected').val(); 

  var c = e1+' / '+e2; 

  $(itgOption).find(".itg_collection_select option[data-value='" + c + "']").prop("selected", true);
  $(itgOption).find(".itg_collection_select option[data-value='" + c + "']").trigger('change');


  var vId = $(itgOption).find('.itg_collection_select option:selected').val();


  $(itgOption).find('.itg_collection_input').val(vId);


});


$(document).on("change",".itg_Size",function(){
  var itgSize= $(this).val();
  var itgColor= $(this).siblings('.itg_Color').find('option:selected').val();  

  var classList = $(this).attr("class");

  var classArr = classList.split(/\s+/);
  var selCls =	classArr[0];
  if(selCls=='sel1'){
    var c = itgSize+' / '+itgColor; 
  }else{
    var c = itgColor+' / '+itgSize; 
  }

  $(this).siblings('.itg_Color').find('option:selected').val();

  $(this).siblings('.itg_collection_select').find("option[data-value='" + c + "']").prop("selected", true);
  $(this).siblings('.itg_collection_select').find("option[data-value='" + c + "']").trigger('change');
  var vId = $(this).siblings('.itg_collection_select').find('option:selected').val();


  $(this).siblings('.itg_collection_input').val(vId);
    $.each(classArr, function(index, value){
        $("body").append("<p>" + index + ": " + value + "</p>");
      }); 

});*/



$(document).ready(function() {

  $('.itgdots .itgspan1').click(function(){
    $('.owl-dots>div:nth-child(1)').trigger('click');
  });
  $('.itgdots .itgspan2').click(function(){
    $('.owl-dots>div:nth-child(2)').trigger('click');
  });
  $('.itgdots .itgspan3').click(function(){
    $('.owl-dots>div:nth-child(3)').trigger('click');
  });
  $('.itgdots .itgspan4').click(function(){
    $('.owl-dots>div:nth-child(4)').trigger('click');
  });
  $('.itgdots .itgspan5').click(function(){
    $('.owl-dots>div:nth-child(5').trigger('click');
  });
  
  
  $('.filter_desktop .Collapsible__Button').click(function(){
    //alert();
    var _parent = $(this).parent('div').toggleClass('show_margins');
    _parent.find('.Collapsible__Inner').toggleClass('show_filter_value');
  });
  $('.itg-main-add-cart').click(function(){
    var selectedval = $('.ProductForm__Item .ProductForm__SelectedValue').text();
    if(selectedval == 'Select Size'){
      $('.show_selct_size_message').show();
      return false;
    } 
  });
  $('.OptionSelector .Popover__Value').click(function(){
    $('.show_selct_size_message').hide();
  });
    
});


 
$(document).on('change','.sel1 ,.sel2',function () {
  var _form = $(this).closest('form');
  $('.show_selct_size_messages').hide();
  var s = _form.find('.sel1 option:selected').val();
  var r = _form.find('.sel2 option:selected').val();
  //alert(s);
  //alert(r);
  var selected = s + ' / ' + r ;
  //alert(selected);
  _form.find(".itg_collection_select option[data-value='"+selected+"']").prop("selected", true);
  var selectedval = _form.find(".itg_collection_select option:selected" ).val();
  
  console.log(selectedval);
  if (selectedval == 'Sold-out'){
    _form.find('.itg_btn_add_cart').text('Sold Out').prop("disabled", true);
  }else {
    _form.find('.itg_btn_add_cart').text('Add to cart').prop("disabled", false);
    _form.find('.itg_collection_input').val(selectedval);
  }
});


$(document).on("click",".ColorSwatch",function(){
   var Color = $(this).attr('title'); 
   var _form = $(this).closest('form');
   _form.find(".itg_Color option").each(function() {
    var data_value_color = $(this).val();
     //alert(data_value_color);
    if ( Color == data_value_color ) {
      $(this).attr('selected','selected').siblings().removeAttr('selected');
      var s = _form.find('.sel1 option:selected').val();
      var r = _form.find('.sel2 option:selected').val();
      //alert(s);
  //alert(r);
      var selected = s + ' / ' + r ;
      //alert(selected);
      _form.find(".itg_collection_select option[data-value='"+selected+"']").prop("selected", true);
      var selectedval = _form.find(".itg_collection_select option:selected" ).val();
      
      if (selectedval == 'Sold-out'){
        _form.find('.itg_btn_add_cart').text('Sold Out').prop("disabled", true);
      }else {
        _form.find('.itg_btn_add_cart').text('Add to cart').prop("disabled", false);
      	_form.find('.itg_collection_input').val(selectedval);
      }
    }
  });
});


$(document).on('click','.itg_btn_add_cart', function(event) {
  event.preventDefault()
  var _form = $(this).closest('form');
  var selectedvaltext = _form.find('.itg_Size option:selected').text();
  var selectedvalue = _form.find(".itg_collection_select option:selected").val();

  if(selectedvaltext == 'Select Size'){
    _form.find('.show_selct_size_messages').show();
    return false;
  } else {
    _form.find('.show_selct_size_messages').hide();
    
    data = {
      "id": selectedvalue,
      "quantity": 1
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        $("#sidebar-cart").load(location.href+" #sidebar-cart>*","");
        $(".rt_cart_drawer").load(location.href+" .rt_cart_drawer>*","");

        setTimeout(function(){
          $("#sidebar-cart").attr("aria-hidden", "false");
          $('.PageOverlay').addClass('is-visible');
        }, 1000);
      },
      error: function () {
        //alert('error')
        _form.find('.itg_btn_add_cart').text('Sold Out').prop("disabled", true);
      }
    });
  }
});
$(document).on('click','#sidebar-cart .Drawer__Close', function(event) {
  $("#sidebar-cart").attr("aria-hidden", "true");
  $('.PageOverlay').removeClass('is-visible');
});